export default __webpack_public_path__ + "static/media/google.af344453.png";